export const CODE_ROLE_LIST = {
  TECHNICIAN: 'DHSL_QLDA_CV',
  QTHT_CC: 'QTHT_CC',
  BDH: 'BDH',
  BDH_CN: 'BDH_CN',
  TB_QLVH: 'TB_QLVH',
  QLML_TB: 'QLML_TB',
  TB_QLDA: 'TB_QLDA',
  TB_MHTT: 'TB_MHTT',
  TB_TC: 'TB_TC',
}
import type { LayoutSetting } from '@/stores/app'

export default {
  title: 'Antdv Pro',
  theme: 'light',
  logo: '/logo.svg',
  collapsed: false,
  drawerVisible: false,
  colorPrimary: '#1677FF',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixedSider: true,
  splitMenus: false,
  header: true,
  menu: true,
  watermark: true,
  menuHeader: true,
  footer: false,
  colorWeak: false,
  colorGray: false,
  multiTab: true,
  multiTabFixed: false,
  keepAlive: true,
  accordionMode: false,
  leftCollapsed: true,
  compactAlgorithm: false,
  headerHeight: 48,
  copyright: 'Antdv Pro Team 2023',
  animationName: 'slide-fadein-right',
} as LayoutSetting

export const animationNameList = [
  {
    label: 'None',
    value: 'none',
  },
  {
    label: 'Fadein Up',
    value: 'slide-fadein-up',
  },
  {
    label: 'Fadein Right',
    value: 'slide-fadein-right',
  },
  {
    label: 'Zoom Fadein',
    value: 'zoom-fadein',
  },
  {
    label: 'Fadein',
    value: 'fadein',
  },
]
export type AnimationNameValueType =
  | 'none'
  | 'slide-fadein-up'
  | 'slide-fadein-right'
  | 'zoom-fadein'
  | 'fadein'
